var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('h2',[_vm._v("Sorry, deze pagina bestaat niet...")]),_vm._v(" "),_c('p',[_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'Home' }}},[_vm._v("Ga terug")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67026297","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SettingsPage.vue
// module id = 531
// module chunks = 1